import { get, post, postJson } from '../tools/async-tool'
// import {Message} from 'element-ui';

import showErr from './showErr'
// function showErr(err) {
//   // 请求取消
//   // alert(JSON.stringify(err));
//   // console.log(err);
//   // console.log(!!(err.status.match(/canceled/i)), err);
//   if(typeof err.status == 'number' && (err.status == 0 || err.status == 401)) { return false; }
//   Message({
//     type: 'error',
//     message: err.body.error ? err.body.error : util.setDefaultErr(),
//     customClass: 'manban-toast__error'
//   });
// }

export function getOrgs (cb, params, failCb = null) {
  let url = '/list_orgs/v3' // /list_orgs
  return get(url, params).then(res => {
    	cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function getCurrentOrg (cb, params, failCb = null) {
  let url = '/org'
  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function loginOut (cb, params, failCb = null) {
  let url = '/logout'
  return post(url, params).then(res => {
    cb(res)
  }, err => {
    showErr(err)

    failCb && failCb()
  })
}

// 检查用户在机构信息是否完善
export function staffCheckInfo (cb, params, failCb = null) {
  let url = '/staff/check_info'
  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

// 设置员工信息
export function staffSetInfo (cb, params, failCb = null) {
  let url = '/staff/set_info.json'
  return postJson(url, params).then(res => {
    cb(res)
  }, err => {
    showErr(err)

    failCb && failCb()
  })
}
